__webpack_require__.p = "https://www1.allstar.gg/";